/**
 * GENERATED FILE — do not edit by hand.
 *
 * Produced by build/write-default-settings.mjs from
 * config/default-settings.json (the single source of truth for the
 * OPTION-SCHEMA defaults). Edit the JSON, then run `npm run build`
 * (or `node build/write-default-settings.mjs` directly) to regenerate.
 *
 * `optionSchemaDefaults` is exactly the set of options
 * includes/Rest/OptionsMapper.php::CAMEL_TO_SNAKE maps — every field
 * Admin/Settings.php's `$defaults` stores, and nothing else (JS-only
 * runtime concerns like `i18n`/`consentGranted`/`consentApiPresent` live
 * in src/modules/defaultSettings.js instead, since they are not stored
 * WordPress options).
 *
 * DEEP-FROZEN below (pr-review-council LOW, 2026-07-02): this one object
 * graph is shared — by reference, via shallow spreads/imports, never
 * cloned — across src/modules/defaultSettings.js and
 * src/admin/store/defaults.js. Freezing
 * it turns an accidental in-place mutation at any one of those call sites
 * (which would silently corrupt the shared template for every OTHER
 * consumer too) into an immediate thrown TypeError in strict mode (every
 * ES module is strict), instead of a hard-to-trace cross-module bug.
 */
/**
 * Recursively Object.freeze() a plain-object/array graph. Local to this
 * generated file on purpose — it has exactly one caller (the export
 * below) and needs zero shared state, so a project-wide utility module
 * would be one more moving part for no reuse benefit.
 *
 * @param {*} value
 * @return {*} The same value, deeply frozen.
 */
function deepFreeze(value) {
    if (value !== null && typeof value === 'object' && !Object.isFrozen(value)) {
        Object.values(value).forEach(deepFreeze);
        Object.freeze(value);
    }
    return value;
}

export const optionSchemaDefaults = deepFreeze({
  "debugMode": false,
  "messengerRewrite": true,
  "normalizeValues": true,
  "shortenerSkip": true,
  "shortenerDomains": [],
  "existingUtm": "skip",
  "clickIdPassthrough": false,
  "clickIdPassthroughDomains": [],
  "clickIdStrictConsent": false,
  "leadBeacon": false,
  "leadBeaconAttribution": [],
  "mediumEnabled": true,
  "mediumValue": "referral",
  "positionContainerSelector": "",
  "utmContentRules": {
    "button_classes": [
      "btn",
      "button",
      "wp-block-button__link"
    ],
    "banner_classes": [
      "banner",
      "wp-block-image"
    ]
  },
  "excludeClasses": [
    "no-utm",
    "internal-link"
  ],
  "excludeDomains": [
    "yandex.ru",
    "fb.com",
    "threads.net",
    "vkontakte.ru",
    "whatsapp.com",
    "whatsapp",
    "flipboard.com",
    "linkedin.com",
    "t.me",
    "twitter.com",
    "instagram.com",
    "google.com",
    "facebook.com",
    "pinterest.com",
    "vk.com"
  ]
});
